export default __webpack_public_path__ + "static/media/rehack-21.1a12c7cc.jpg";